import { FaChevronUp, FaChevronDown, FaSearch, FaShoppingCart, FaHeart } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CrispChatLoader from './utils/crisp';
import InstallPrompt from './utils/InstallPromptToMobile';

import ActionButton from 'components/buttons/ActionButton';
import { getIcon } from 'utils/icons';
import {
    getAlreadyOrderedProducts,
    getAutoOrderConditions,
    getPaginatedAutoOrderProducts,
    sendAutoOrder,
} from 'interfaces/autoOrder';
import InputField from 'components/fields/InputField';
import ProductCard from './ProductCard';
import ProductLoadingCard from './ProductLoadingCard';
import { useDisclosure } from '@chakra-ui/hooks';
import AnnounceModal from 'views/admin/main/ecommerce/commandPage/default-toola/AnnounceModal';
import Header from '../default-toola/Header';
import ProductViewModal from '../default-toola/ProductViewModal';
import { icons } from 'views/stock/updateProduct/components/CreateCategory';

const CART_STORAGE_KEY = 'toola_b2b_cart';

const CommandInfo = (props: { haveMultipleSupliers: boolean }) => {
    const { haveMultipleSupliers } = props;

    const nav = useNavigate();
    const [autoOrderProducts, setAutoOrderProducts] = useState([]);
    const [alreadyOrderedProducts, setAlreadyOrderedProducts] = useState([]);
    const [autoOrderProductsMeta, setAutoOrderProductsMeta] = useState(null);
    const [newOrder, setNewOrder] = useState<any>(() => {
        const savedCart = localStorage.getItem(CART_STORAGE_KEY);
        if (savedCart) {
            try {
                return JSON.parse(savedCart);
            } catch (e) {
                console.error('Erreur lors du chargement du panier:', e);
            }
        }
        return { items: [], totalPrice: 0 };
    });
    const [search, setSearch] = useState('');
    const [dateError, setDateError] = useState(null);
    const [page, setPage] = useState(1);
    const [disableSendButton, setDisableSendButton] = useState(false);
    const isFullyLoaded = autoOrderProducts.length > 0 && autoOrderProductsMeta;
    const [showOrderSummary, setShowOrderSummary] = useState(false);
    const [productsPerLoad, setProductsPerLoad] = useState(0);
    const [companyInfos, setCompanyInfos] = useState<any>(null);
    const [conditions, setConditions] = useState<any>(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [category, setCategory] = useState('all');

    const [selectedProductId, setSelectedProductId] = useState(0);
    const [confirmPage, setConfirmPage] = useState(false);

    const [ownerId, setOwnerId] = useState<string | null>(null);

    const {
        isOpen: isOpenProductView,
        onOpen: onOpenProductView,
        onClose: onCloseProductView,
    } = useDisclosure();
    const productsPerScroll = 36;

    useEffect(() => {
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(newOrder));
    }, [newOrder]);

    const handleChange = (e: any) => {
        setNewOrder((prevCustomer: any) => ({
            ...prevCustomer,
            [e.target.id]: e.target.value,
        }));
    };

    const handleDateChange = (e: any) => {
        const today = new Date();
        const date = new Date(e.target.value);
        const day = date
            .toLocaleDateString('en-US', { weekday: 'long' })
            .toLowerCase();

        date.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (conditions && conditions.blockedDays.includes(day)) {
            let error = 'Livraisons indisponible le ';

            conditions.blockedDaysFr.forEach(
                (blockedDay: any, index: number) => {
                    if (index === 0) error += blockedDay;
                    else if (index === conditions.blockedDaysFr.length - 1)
                        error += ' et ' + blockedDay;
                    else error += ', ' + blockedDay;
                },
            );
            setDateError(error);
            handleChange({ target: { id: 'deliveryDate', value: '' } });
            return;
        }

        if (conditions && conditions.deliveryDelay !== 0) {
            const deliveryDelay = conditions.deliveryDelay;
            const deliveryDate = new Date(e.target.value);

            const dateOrderAvailable = new Date();
            dateOrderAvailable.setHours(0, 0, 0, 0);
            dateOrderAvailable.setDate(
                dateOrderAvailable.getDate() + deliveryDelay,
            );

            if (dateOrderAvailable > deliveryDate) {
                setDateError(
                    `La date de livraison doit être au moins dans ${deliveryDelay} jours`,
                );
                handleChange({ target: { id: 'deliveryDate', value: '' } });
                return;
            }
        }

        if (date < today) {
            setDateError('La date de livraison ne peut pas être dans le passé');
            handleChange({ target: { id: 'deliveryDate', value: '' } });
            return;
        }
        setDateError(null);
        handleChange(e);
    };

    const fetchProducts = async (firstLoad = false) => {
        const res = await getPaginatedAutoOrderProducts(page, 500);
        if (res) {
            setCompanyInfos({
                company: res.company,
                customerCompany: res.customerCompany,
                customerEmail: res.customerEmail,
                logo: res.companyLogoUrl,
                hidePricesOnShop: res.hidePricesOnShop,
                contact: res.contact,
                announcements: res.announcements,
                categories: res.categories,
                customerId: res.customerId,
            });

            if (res.companyOwnerId) {
                setOwnerId(res.companyOwnerId);
            }

            if (res.announcements) onOpen();

            setAutoOrderProducts(() => [...res.products]);
            setPage(firstLoad ? 1 : (prevPage) => prevPage + 1);
            setAutoOrderProductsMeta(res.meta);
            if (firstLoad) {
                setProductsPerLoad(productsPerScroll);
            }
        }
    };

    const sendOrder = async () => {
        if (disableSendButton) return;

        const data = { ...newOrder };
    data.items = data.items.filter(
        (i: any) => i.quantity > 0 && i.quantity !== '',
    );

    setDisableSendButton(true);

    data.items = data.items.map((i: any) => {
        delete i.img;
        return i;
    });
    
    const res = await sendAutoOrder(newOrder);
    if (res) {
        localStorage.removeItem(CART_STORAGE_KEY);
        setNewOrder({ items: [], totalPrice: 0 });

        if (res.orderId) nav(`/command/success?id=${res.orderId}`);
        else nav('/command/success');
    } else {
        setTimeout(() => {
            setDisableSendButton(false);
        }, 3000);
    }
};

    const searchProduct = (product: any, search: string) => {
        for (const key in product)
            if (
                product[key] &&
                typeof product[key] === 'string' &&
                product[key]
                    .toLocaleLowerCase()
                    .includes(search.toLocaleLowerCase())
            )
                return true;
        return false;
    };

    const addNewItem = (
        productId: string,
        name: string,
        quantity: number,
    ) => {
        let updatedItems: any = [];
        const alreadyExist = newOrder.items.find(
            (i: any) => i.productId === productId,
        );
        
        let price: any = null;
        let unity: any = null;
        
        const parentProduct = autoOrderProducts.find((p: any) => p.id === productId);
        
        if (parentProduct) {
            price = parentProduct.price;
            unity = parentProduct.unity;
        } else {
            for (const parent of autoOrderProducts) {
                if (parent.children && parent.children.length > 0) {
                    const child = parent.children.find((c: any) => c.id === productId);
                    if (child) {
                        price = child.price;
                        unity = child.unity;
                        break;
                    }
                }
            }
        }
        
        if (price === null || unity === null) {
            console.error('Produit non trouvé:', productId);
            return;
        }
    
        const img = getIcon(name, 'product');
    
        if (alreadyExist) {
            updatedItems = newOrder.items.map((item: any) => {
                if (item.productId === productId) {
                    return {
                        ...item,
                        quantity: item.quantity + quantity,
                    };
                }
                return item;
            });
        } else {
            updatedItems = [...newOrder.items];
            updatedItems.push({
                productId: productId,
                quantity: quantity,
                unity: unity,
                img: img,
                name,
                price,
            });
        }
    
        setNewOrder((prevCustomer: any) => ({
            ...prevCustomer,
            items: updatedItems,
            totalPrice: prevCustomer.totalPrice + price * quantity,
        }));
    };

    const removeItem = (productId: string) => {
        const itemToRemove = newOrder.items.find(
            (i: any) => i.productId === productId,
        );
        if (!itemToRemove) return;

        let totalPrice = newOrder.totalPrice;

        if (itemToRemove.quantity >= 1)
            totalPrice -= itemToRemove.price * itemToRemove.quantity;

        let updatedItems = newOrder.items.map((item: any) => {
            if (item.productId === productId) {
                return {
                    ...item,
                    quantity: item.quantity - itemToRemove.quantity,
                };
            }
            return item;
        });

        updatedItems = updatedItems.filter((item: any) => item.quantity > 0);

        setNewOrder((prevCustomer: any) => ({
            ...prevCustomer,
            items: updatedItems,
            totalPrice,
        }));
    };

    const handleQuantityChange = (quantity: number, id: string) => {
        if (quantity === 0) {
            return removeItem(id);
        }

        const updatedItem = newOrder.items.find((i: any) => i.productId === id);

        let totalPrice =
            newOrder.totalPrice - updatedItem.quantity * updatedItem.price;
        totalPrice += quantity * updatedItem.price;

        setNewOrder((prevCustomer: any) => ({
            ...prevCustomer,
            items: prevCustomer.items.map((item: any) => {
                if (item.productId === id) {
                    return {
                        ...item,
                        quantity: quantity,
                    };
                }
                return item;
            }),
            totalPrice: totalPrice,
        }));
    };

    const fetchAlreadyOrderedProducts = async () => {
        const res = await getAlreadyOrderedProducts();
        if (res) setAlreadyOrderedProducts(res);
    };

    const fetchConditions = async () => {
        const res = await getAutoOrderConditions();
        if (res) setConditions(res);
    };

    const getOrderCount = (productId: any) => {
        const sum = alreadyOrderedProducts.find((p: any) => p._id === productId)
            ?.count;
        return sum ? sum : 0;
    };

    const productsHaveFav = () => {
        if (!autoOrderProducts || !alreadyOrderedProducts) return false;
        for (const product of autoOrderProducts) {
            const fav = alreadyOrderedProducts.find(
                (p: any) => p._id === product.id,
            );
            if (fav) return true;
        }
        return false;
    };

    useEffect(() => {
        fetchProducts(true);
        fetchAlreadyOrderedProducts();
        fetchConditions();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50">
            {ownerId && companyInfos && (
                <CrispChatLoader 
                    ownerId={ownerId}
                    userEmail={companyInfos.customerEmail}
                    userName={companyInfos.customerCompany}
                    userId={companyInfos.customerId}
                />
            )}
            {/* Install PWA */}
            <InstallPrompt />
            <AnnounceModal
                isOpen={isOpen}
                onClose={onClose}
                description={companyInfos ? companyInfos.announcements : ''}
            />

            {autoOrderProducts && selectedProductId ? (
                <ProductViewModal
                    isOpen={isOpenProductView}
                    onClose={() => {
                        onCloseProductView();
                        setSelectedProductId(null);
                    }}
                    product={autoOrderProducts.find(
                        (p: any) => p.id === selectedProductId,
                    )}
                    newOrder={newOrder}
                    hidePricesOnShop={companyInfos ? companyInfos.hidePricesOnShop : false}
                    onAddProduct={addNewItem}
                    onQuantityChange={handleQuantityChange}
                />
            ) : null}

            {/* Header */}
            <div className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200/50 shadow-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="py-4">
                        <Header
                            companyInfos={companyInfos}
                            haveMultipleSupliers={haveMultipleSupliers}
                        />
                    </div>

                    {/* search bar*/}
                    {!confirmPage && (
                        <div className="pb-4 relative">
                            <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 z-10" />
                            <input
                                type="text"
                                placeholder="Rechercher un produit..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full pl-11 pr-4 py-3 bg-slate-100/50 border border-slate-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all text-sm"
                            />
                        </div>
                    )}
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4">
                {/* Categories with modern design */}
                {companyInfos &&
                    !confirmPage &&
                    companyInfos.categories &&
                    companyInfos.categories.length > 0 && (
                        <div className="mt-4 flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
                            <button
                                className={`flex items-center gap-2 px-4 py-2 rounded-xl whitespace-nowrap transition-all text-sm font-medium ${
                                    'all' === category
                                        ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/30'
                                        : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200'
                                }`}
                                onClick={() => setCategory('all')}
                            >
                                Tout
                            </button>
                            {productsHaveFav() && (
                                <button
                                    className={`flex items-center gap-2 px-4 py-2 rounded-xl whitespace-nowrap transition-all text-sm font-medium ${
                                        'fav' === category
                                            ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/30'
                                            : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200'
                                    }`}
                                    onClick={() => setCategory('fav')}
                                >
                                    <FaHeart className="text-red-500" />
                                    Favoris
                                </button>
                            )}
                            {companyInfos.categories
                                .filter((c: any) =>
                                    autoOrderProducts.find(
                                        (p: any) => p.category === c.id,
                                    ),
                                )
                                .map((cat: any) => (
                                    <button
                                        key={cat.id}
                                        className={`flex items-center gap-2 px-4 py-2 rounded-xl whitespace-nowrap transition-all text-sm font-medium ${
                                            cat.id === category
                                                ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/30'
                                                : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200'
                                        }`}
                                        onClick={() => setCategory(cat.id)}
                                    >
                                        {icons.find((i: any) => i.name === cat.icon)?.icon || ''}
                                        {cat.name}
                                    </button>
                                ))}
                        </div>
                    )}

                {/* Order detals */}
                    {confirmPage && (
                        <div className="relative py-6">
                            <button
                                className="mb-4 text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
                                onClick={() => setConfirmPage(false)}
                            >
                                {'← Retour à la boutique B2B'}
                            </button>
                            
                            <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
                                <div className="p-6 border-b border-slate-200">
                                    <h2 className="text-2xl font-bold text-slate-800 mb-2">Finaliser la commande</h2>
                                </div>
                    
                                <div className="p-6">
                                    <h3 className="text-xl font-bold text-slate-800 mb-4">Récapitulatif de la commande</h3>
                                    {newOrder.items.length > 0 ? (
                                        <div className="space-y-3">
                                            {newOrder.items.map((item: any) => (
                                                <div key={item.productId} className="p-4 bg-slate-50 rounded-xl">
                                                    {/* Product name at the top on mobile*/}
                                                    <div className="flex items-start justify-between gap-3 mb-3">
                                                        <div className="flex-1 min-w-0">
                                                            <p className="font-medium text-slate-800 text-sm sm:text-base">{item.name}</p>
                                                            <p className="text-xs sm:text-sm text-slate-500 mt-1">
                                                                {item.unity}
                                                            </p>
                                                        </div>
                                                        
                                                        <button
                                                            onClick={() => removeItem(item.productId)}
                                                            className="p-2 hover:bg-red-50 rounded-lg text-red-500 transition-colors flex-shrink-0"
                                                        >
                                                            <RxCross2 size={18} />
                                                        </button>
                                                    </div>
                    
                                                    {/* Quantity controls and price at the bottom */}
                                                    <div className="flex items-center justify-between gap-3">
                                                        {/* Quantity controls */}
                                                        <div className="flex items-center gap-2">
                                                            <button
                                                                onClick={() => handleQuantityChange(Math.max(0, item.quantity - 1), item.productId)}
                                                                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-white hover:bg-slate-200 rounded-lg border border-slate-300 transition-colors"
                                                            >
                                                                <AiOutlineMinus size={14} className="text-slate-700" />
                                                            </button>
                                                            <input
                                                                type="number"
                                                                value={item.quantity}
                                                                onChange={(e) => {
                                                                    const val = parseFloat(e.target.value);
                                                                    if (!isNaN(val) && val >= 0) {
                                                                        handleQuantityChange(val, item.productId);
                                                                    }
                                                                }}
                                                                className="w-14 sm:w-16 h-8 sm:h-9 text-center font-semibold text-sm rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            />
                                                            <button
                                                                onClick={() => handleQuantityChange(item.quantity + 1, item.productId)}
                                                                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
                                                            >
                                                                <AiOutlinePlus size={14} className="text-white" />
                                                            </button>
                                                        </div>
                    
                                                        {/* Price */}
                                                        {!companyInfos.hidePricesOnShop && (
                                                            <p className="text-base sm:text-lg font-bold text-blue-600 whitespace-nowrap">
                                                                {(item.price * item.quantity).toFixed(2)} €
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            
                                            {!companyInfos.hidePricesOnShop && (
                                                <div className="pt-4 border-t border-slate-200 flex justify-between items-center">
                                                    <p className="text-base sm:text-lg font-semibold text-slate-800">Total HT</p>
                                                    <p className="text-xl sm:text-2xl font-bold text-blue-600">
                                                        {newOrder.totalPrice.toFixed(2)}€
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="text-center py-8 text-slate-500">
                                            Votre commande ne contient aucun produit
                                        </p>
                                    )}
                                </div>
                    
                                {/* Recommendations Section - Upsell */}
                                {newOrder.items.length > 0 && (
                                    <div className="p-6 border-t border-slate-200 bg-gradient-to-br from-blue-50/50 to-slate-50">
                                        <div className="flex items-center gap-2 mb-4">
                                            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                                                <span className="text-white text-lg">✨</span>
                                            </div>
                                            <h3 className="text-base sm:text-lg font-bold text-slate-800">
                                                Nos clients ont aussi commandé
                                            </h3>
                                        </div>
                                        
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                            {autoOrderProducts
                                                .filter((p: any) => !newOrder.items.find((item: any) => item.productId === p.id))
                                                .sort((a: any, b: any) => getOrderCount(b.id) - getOrderCount(a.id))
                                                .slice(0, 4)
                                                .map((product: any) => {
                                                    const inCart = newOrder.items.find((i: any) => i.productId === product.id);
                                                    return (
                                                        <div
                                                            key={product.id}
                                                            className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:border-blue-300 hover:shadow-lg transition-all group"
                                                        >
                                                            <div className="relative h-24 bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
                                                                <img
                                                                    className="max-h-16 object-contain group-hover:scale-110 transition-transform duration-300"
                                                                    src={
                                                                        Array.isArray(product.imageUrls) && product.imageUrls.length > 0
                                                                            ? product.imageUrls[0]
                                                                            : product.imageUrl || getIcon(product.name, 'product')
                                                                    }
                                                                    alt={product.name}
                                                                    onError={(e: any) => {
                                                                        e.target.src = getIcon(product.name, 'product');
                                                                    }}
                                                                />
                                                                
                                                                {getOrderCount(product.id) > 10 && (
                                                                    <div className="absolute top-1 right-1 bg-red-500 text-white px-1.5 py-0.5 rounded text-xs font-bold">
                                                                        ❤️
                                                                    </div>
                                                                )}
                                                            </div>
                    
                                                            <div className="p-3">
                                                                <h4 className="font-semibold text-slate-800 text-sm line-clamp-2 mb-1 min-h-[2.5rem]">
                                                                    {product.name}
                                                                </h4>
                                                                
                                                                {!companyInfos?.hidePricesOnShop && (
                                                                    <div className="flex items-baseline gap-1 mb-2">
                                                                        <span className="text-lg font-bold text-blue-600">
                                                                            {product.price.toFixed(2)}€
                                                                        </span>
                                                                        <span className="text-xs text-slate-500">/ {product.unity}</span>
                                                                    </div>
                                                                )}
                    
                                                                {!inCart ? (
                                                                    <button
                                                                        onClick={() => addNewItem(product.id, product.name, 1)}
                                                                        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-2 rounded-lg text-sm font-medium transition-all hover:shadow-md flex items-center justify-center gap-1"
                                                                    >
                                                                        <AiOutlinePlus size={14} />
                                                                        <span>Ajouter</span>
                                                                    </button>
                                                                ) : (
                                                                    <div className="flex items-center gap-1">
                                                                        <button
                                                                            onClick={() => handleQuantityChange(inCart.quantity - 1, product.id)}
                                                                            className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 py-1.5 rounded-lg transition-colors"
                                                                        >
                                                                            <AiOutlineMinus className="w-3 h-3 mx-auto" />
                                                                        </button>
                                                                        <div className="flex-1 text-center font-bold text-sm">
                                                                            {inCart.quantity}
                                                                        </div>
                                                                        <button
                                                                            onClick={() => handleQuantityChange(inCart.quantity + 1, product.id)}
                                                                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-1.5 rounded-lg transition-colors"
                                                                        >
                                                                            <AiOutlinePlus className="w-3 h-3 mx-auto" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                    
                                        <div className="mt-4 p-3 bg-blue-100/50 border border-blue-200 rounded-xl">
                                            <p className="text-sm text-blue-900 text-center">
                                                💡 <span className="font-semibold">Astuce :</span> Complétez votre commande pour optimiser votre livraison
                                            </p>
                                        </div>
                                    </div>
                                )}
                    
                                {/*Delivery informations */}
                                <div className="p-6 bg-slate-50 border-t border-slate-200">
                                    <h3 className="text-lg font-bold text-slate-800 mb-4">Informations de livraison</h3>
                                    <div className="space-y-4">
                                        <div>
                                            <InputField
                                                label="Date de livraison*"
                                                id="deliveryDate"
                                                type="date"
                                                min={new Date().toISOString().split('T')[0]}
                                                onChange={handleDateChange}
                                                inputSmall={true}
                                            />
                                            {dateError && (
                                                <p className="mt-2 text-red-500 text-xs">{dateError}.</p>
                                            )}
                                        </div>
                                        <div>
                                            <InputField
                                                label="Information livreur"
                                                placeholder="Porte 2, code 7678"
                                                id="customerNotes"
                                                type="text"
                                                onChange={handleChange}
                                                inputSmall={true}
                                            />
                                        </div>
                                    </div>
                    
                                    <button
                                        className={`w-full mt-6 py-4 rounded-xl text-sm font-semibold transition-all ${
                                            newOrder.items.length > 0 &&
                                            newOrder.deliveryDate &&
                                            (conditions && conditions.minimumOrderAmount
                                                ? newOrder.totalPrice >= conditions.minimumOrderAmount
                                                : true)
                                                ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg hover:shadow-xl'
                                                : 'bg-slate-300 text-slate-500 cursor-not-allowed'
                                        }`}
                                        disabled={disableSendButton}
                                        onClick={() => {
                                            if (newOrder.items.length > 0 && newOrder.deliveryDate) {
                                                sendOrder();
                                            }
                                        }}
                                    >
                                        Envoyer la commande
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                {confirmPage === false && (
                    <>
                        {/* Products grid */}
                        <div className="mt-4 pb-32">
                            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                                {isFullyLoaded
                                    ? autoOrderProducts
                                          .filter((p: any) => searchProduct(p, search))
                                          .filter((p: any) =>
                                              category === 'all' || category === 'fav'
                                                  ? true
                                                  : p.category === category,
                                          )
                                          .filter((p: any) =>
                                              category === 'fav'
                                                  ? getOrderCount(p.id) > 0
                                                  : true,
                                          )
                                          .sort(
                                              (a: any, b: any) =>
                                                  getOrderCount(b.id) - getOrderCount(a.id),
                                          )
                                          .map((product: any, index: number) => {
                                              return (
                                                  <ProductCard
                                                      id={product.id}
                                                      key={index}
                                                      name={product.name}
                                                      imageUrl={product.imageUrl}
                                                      type={product.type}
                                                      alert={product.alert}
                                                      img={getIcon(product.name, 'product')}
                                                      imageUrls={
                                                        Array.isArray(product.imageUrls) && product.imageUrls.length > 0
                                                        ? product.imageUrls
                                                        : product.imageUrl
                                                            ? [product.imageUrl]
                                                            : []
                                                      }
                                                      unity={product.unity}
                                                      price={companyInfos && companyInfos.hidePricesOnShop ? 0 : product.price}
                                                      hidePricesOnShop={companyInfos ? companyInfos.hidePricesOnShop : false}
                                                      subUnitQuantity={product.subUnitQuantity}
                                                      subUnity={product.subUnity}
                                                      onAddProduct={addNewItem}
                                                      onQuantityChange={handleQuantityChange}
                                                      quantity={
                                                          newOrder.items.find(
                                                              (i: any) => i.productId === product.id,
                                                          )?.quantity
                                                      }
                                                      orderedCount={getOrderCount(product.id)}
                                                      remove={removeItem}
                                                      order={newOrder}
                                                      onClick={() => {
                                                          setSelectedProductId(product.id);
                                                          onOpenProductView();
                                                      }}
                                                  />
                                              );
                                          })
                                    : Array(productsPerLoad)
                                          .fill(<ProductLoadingCard />)
                                          .map((product: any, i: number) => (
                                              <ProductLoadingCard key={i} />
                                          ))}
                            </div>
                            
                            {isFullyLoaded && autoOrderProducts.length < autoOrderProductsMeta.total && (
                                <div className="mt-6 text-center">
                                    <div className="inline-block">
                                        <svg
                                            className="w-8 h-8 text-blue-600 animate-spin"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            />
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            />
                                        </svg>
                                    </div>
                                    <p className="mt-2 text-sm text-slate-500">Chargement des produits...</p>
                                </div>
                            )}
                        </div>

                        {/* Card for sell */}
                        <div className="fixed bottom-0 left-0 right-0 z-50">
                            <div className="max-w-7xl mx-auto px-4 pb-4">
                                <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
                                    <button
                                        onClick={() => setShowOrderSummary(!showOrderSummary)}
                                        className="w-full p-4 flex items-center justify-between hover:bg-slate-50 transition-colors"
                                    >
                                        <div className="flex items-center gap-3">
                                            <div className="relative">
                                                <FaShoppingCart className="w-6 h-6 text-blue-600" />
                                                {newOrder.items.length > 0 && (
                                                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                                                        {newOrder.items.length}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="text-left">
                                                <p className="text-sm font-semibold text-slate-800">
                                                    {newOrder.items.length} produit{newOrder.items.length !== 1 ? 's' : ''}
                                                </p>
                                                {!companyInfos || !companyInfos.hidePricesOnShop ? (
                                                    <p className="text-xs text-slate-500">
                                                        Total HT: <span className="font-bold text-blue-600">{newOrder.totalPrice.toFixed(2)}€</span>
                                                    </p>
                                                ) : null}
                                                {conditions && conditions.minimumOrderAmount && conditions.minimumOrderAmount > 0 && (
                                                    <p className="text-xs text-slate-500">
                                                        Min. {conditions.minimumOrderAmount}€
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            {showOrderSummary ? (
                                                <FaChevronDown className="w-4 h-4 text-slate-600" />
                                            ) : (
                                                <FaChevronUp className="w-4 h-4 text-slate-600" />
                                            )}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (
                                                        newOrder.items.length > 0 &&
                                                        (conditions && conditions.minimumOrderAmount
                                                            ? newOrder.totalPrice >= conditions.minimumOrderAmount
                                                            : true)
                                                    ) {
                                                        setConfirmPage(true);
                                                    }
                                                }}
                                                className={`px-6 py-2.5 rounded-xl text-sm font-semibold transition-all ${
                                                    newOrder.items.length > 0 &&
                                                    (conditions && conditions.minimumOrderAmount
                                                        ? newOrder.totalPrice >= conditions.minimumOrderAmount
                                                        : true)
                                                        ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg hover:shadow-xl'
                                                        : 'bg-slate-300 text-slate-500 cursor-not-allowed'
                                                }`}
                                            >
                                                Commander
                                            </button>
                                        </div>
                                    </button>

                                    {/* Details of the expandable basket */}
                                {showOrderSummary && newOrder.items.length > 0 && (
                                    <div className="border-t border-slate-200 max-h-96 overflow-y-auto">
                                        {newOrder.items.map((item: any) => (
                                            <div
                                                key={item.productId}
                                                className="p-4 flex items-center gap-4 hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-0"
                                            >
                                                <div className="flex-1">
                                                    <p className="font-medium text-slate-800 text-sm">{item.name}</p>
                                                    <p className="text-xs text-slate-500">
                                                        {item.quantity} {item.unity}
                                                    </p>
                                                </div>
                                                {!companyInfos.hidePricesOnShop && (
                                                    <p className="font-bold text-blue-600 text-sm">
                                                        {(item.quantity * item.price).toFixed(2)}€
                                                    </p>
                                                )}
                                                <button
                                                    onClick={() => removeItem(item.productId)}
                                                    className="p-2 hover:bg-red-50 rounded-lg text-red-500 transition-colors"
                                                >
                                                    <RxCross2 size={18} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    </div>
);
};

export default CommandInfo;